import type { IconComponent } from '@components/icons/types'

/** Hamburger menu icon (three horizontal lines) */
export const Menu: IconComponent = ({
    width = '24',
    height = '18',
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 24 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <line
            x1='1'
            y1='1'
            x2='23'
            y2='1'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
        />
        <line
            x1='1'
            y1='9'
            x2='23'
            y2='9'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
        />
        <line
            x1='1'
            y1='17'
            x2='23'
            y2='17'
            stroke='currentColor'
            strokeWidth='3'
            strokeLinecap='round'
        />
    </svg>
)
